import { useSelector } from 'react-redux';
import { List, ListItem } from '@cdl/heartbeat-react';
import { manualAbnormalitiesSelector } from '../selectors/user-diagnostic.selectors';
import { Abnormality } from '../types/diagnostic';
import { DiagnosticLabel } from './DiagnosticLabel';

interface Props {
  deleteAbnormality: (abnormality: Abnormality) => void;
}

export const DiagnosticLabelList: React.FC<Props> = ({ deleteAbnormality }) => {
  const storedAbnormalities = useSelector(manualAbnormalitiesSelector);
  return (
    <List spacing='s'>
      {storedAbnormalities.map((abnormality) => (
        <ListItem key={abnormality.code}>
          <DiagnosticLabel
            abnormality={abnormality}
            deleteAbnormality={deleteAbnormality}
          />
        </ListItem>
      ))}
    </List>
  );
};
